module.exports = __webpack_public_path__ + "static/media/quiz-img1.f06ba3b9.png";